export enum UserRole {
    EDITOR = 'EDITOR',
    AUTHOR = 'AUTHOR',
}